import { useState, useEffect } from 'react';
import {  getSectionData } from '../services/firebaseService';

// Generic hook 
export const useSectionData = (collectionName, docId = null) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const sectionData = await getSectionData(collectionName, docId);
        setData(sectionData);
      } catch (err) {
        setError(err.message);
        console.error(`Error fetching ${collectionName}:`, err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [collectionName, docId]);

  return { data, loading, error };
};